import { Navigate } from 'react-router-dom'
import { isAdmin, isAuthenticated } from '../../services/Auth'
import AdminNavBar from './AdminNavBar'
import AllBookingDetails from './AllBookingDetails'

export default function Dashboard() {
  if (!isAuthenticated() || !isAdmin()) {
        return <Navigate to="/login" />
    }
    
  return (
    <>
    <div>
        <AdminNavBar />
        <AllBookingDetails />
    </div>
    </>
  )
}
